"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Loading = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var adornmentMargins = {
  md: 8,
  sm: 8,
  xs: 4
};
var adornmentStyles = {
  start: (0, _styledComponents.css)(["flex-direction:row;> svg,> div:first-child{margin-right:", ";}"], function (props) {
    return props.theme.spacing[adornmentMargins[props.size]];
  }),
  end: (0, _styledComponents.css)(["flex-direction:row-reverse;> svg,> div:first-child{margin-left:", ";}"], function (props) {
    return props.theme.spacing[adornmentMargins[props.size]];
  })
};
var Wrapper = _styledComponents["default"].button.withConfig({
  displayName: "NewButtonstyle__Wrapper",
  componentId: "sc-1gfpl9z-0"
})(["", ";", ";", ";", ";", ";", " ", ";", ";@media only screen and (max-width:", "){", ";", ";}@media only screen and (min-width:", "){", ";", ";}"], function (props) {
  return props.theme.newButton.base;
}, function (props) {
  return props.theme.newButton[props.color];
}, function (props) {
  return props.theme.newButton[props.appearance];
}, function (props) {
  return props.theme.newButton[props.size];
}, function (props) {
  return props.disabled && props.appearance !== 'text' && props.theme.newButton.disabled;
}, function (props) {
  return props.adornmentPosition && adornmentStyles[props.adornmentPosition];
}, function (props) {
  return props.isLoading && (0, _styledComponents.css)(["pointer-events:none;cursor:not-allowed;"]);
}, function (props) {
  return props.uppercase && (0, _styledComponents.css)(["text-transform:uppercase;"]);
}, function (props) {
  return props.theme.screen.sm;
}, function (props) {
  return [true, 'mobile'].includes(props.rounded) && (0, _styledComponents.css)(["border-radius:1000vw;"]);
}, function (props) {
  return [true, 'mobile'].includes(props.fullWidth) && (0, _styledComponents.css)(["width:100%;"]);
}, function (props) {
  return props.theme.screen.sm;
}, function (props) {
  return [true, 'desktop'].includes(props.rounded) && (0, _styledComponents.css)(["border-radius:1000vw;"]);
}, function (props) {
  return [true, 'desktop'].includes(props.fullWidth) && (0, _styledComponents.css)(["width:100%;"]);
});
exports.Wrapper = Wrapper;
var Loading = _styledComponents["default"].img.withConfig({
  displayName: "NewButtonstyle__Loading",
  componentId: "sc-1gfpl9z-1"
})([""]);
exports.Loading = Loading;
//# sourceMappingURL=NewButton.style.js.map